import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { auth, db } from './firebase'; 
import { doc, getDoc } from 'firebase/firestore';

const Navbar = ({ user }) => {
  const [pseudo, setPseudo] = useState('');
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fetchPseudo = async () => {
      if (user) {
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          setPseudo(userDoc.data().pseudo || 'Utilisateur');
        }
      }
    };

    fetchPseudo();

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [user]);

  const handleLogout = () => {
    auth.signOut();
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-logo">
        <Link to="/">
          <img
            src="/images/dwag_bleu.png"
            alt="Logo Dwag"
            className={scrolled ? 'scrolled' : ''}
          />
          <span className="navbar-title">
            <span>D</span>
            <span>W</span>
            <span>A</span>
            <span>G</span>
          </span>
        </Link>
      </div>

      <div className="navbar-links">
        <Link to="/" className={isActive("/") ? "active" : ""}>Accueil</Link>
        <Link to="/account" className={isActive("/account") ? "active" : ""}>Compte</Link>
        <Link to="/quizz" className={isActive("/quizz") ? "active" : ""}>Quiz</Link>
        <Link to="/speedrun" className={isActive("/speedrun") ? "active" : ""}>Speed Run</Link>
        <Link to="/learn" className={isActive("/learn") ? "active" : ""}>Apprendre</Link>
      </div>

      <div className="navbar-auth">
        {user ? (
          <>
            <span className="navbar-user">{pseudo}</span>
            <button className="navbar-logout" onClick={handleLogout}>
              Déconnexion
            </button>
          </>
        ) : (
          <Link to="/login">
            <button className="navbar-login">Connexion</button>
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;